import { memo, useMemo } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTransition } from "react-spring";
import { InfoIcon } from "../InfoIcon/InfoIcon";
import { CardItem } from "./CardItem";
import { ImageItem } from "./ImageItem";
import { ItemsHeader } from "./ItemsHeader";
import "./styles.scss";
import { TextItem } from "./TextItem";
import useFilterColor from "./useFilterColor";

export const ItemsSection = memo(({ component, componentItems, children, ...props }) => {
  const filteredColors = useFilterColor({ componentItems, component });
  const animationOnItems = useTransition(filteredColors, {
    trail: 40,
    initial: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
    update: { enter: { opacity: 1, scale: 1 } },
    reset: true,
  });

  // the reactComponent is set on each item in items.json
  const getItemComponent = (item, style) => {
    const itemToComponentMap = {
      textItem: <TextItem component={component} item={item} animation={style} />,
      imageItem: <ImageItem component={component} item={item} animation={style} />,
      cardItem: <CardItem component={component} item={item} animation={style} />,
    };
    return itemToComponentMap[item.reactComponent];
  };

  const dataToDisplayTransitionArray = useMemo(() => animationOnItems, [component]);

  const colNumber = useMemo(() => {
    if (component.items.length < 2) return 6;
    else if (component.items.length === 3) return 4;
    else return 3;
  }, [component.items.length]);
  // button items shown in UI
  const items = dataToDisplayTransitionArray((style, item, key, index) => {
    if (item.reactComponent === "headingItem") {
      return (
        <h4 className="section-title d-flex align-items-center">
          {item.title}
          {item.infoContent && <InfoIcon title={item.infoContent.title} content={item.infoContent.content} className="ms-2" />}
        </h4>
      );
    }
    return (
      <Col key={item._id} xs={colNumber} className="my-2">
        {getItemComponent(item, style)}
      </Col>
    );
  });
  return (
    <div className="ItemsSection my-3">
      <ItemsHeader component={component} componentItems={componentItems} {...props} />
      <Row className="items text-center justify-content-around">
        {items}
        {children}
      </Row>
    </div>
  );
});
